// this file is generated by 'scripts/generate-configs'
export const HASH = '243c3061';
